<script src="<%= BASE_URL %>plugins/jquery/jquery-3.6.0.min.js"></script>
<template>
  <div>
    <DxLoadPanel
      :visible="loadingVisible"
      :show-indicator="showIndicator"
      :show-pane="showPane"
      :shading="shading"
      :close-on-outside-click="closeOnOutsideClick"
      shading-color="rgba(0,0,0,0.4)"
    />
    <div v-if="showUploadProgress || showDownloadProgress" class="cc-progress-overlay">
      <div class="cc-progress-card">
        <p class="cc-progress-label">
          {{ showUploadProgress ? 'Subiendo archivo' : 'Descargando archivo' }}...
          <strong>{{ showUploadProgress ? uploadProgress : downloadProgress }}%</strong>
        </p>
        <div class="cc-progress-track">
          <div class="cc-progress-fill" :style="{ width: (showUploadProgress ? uploadProgress : downloadProgress) + '%' }"></div>
        </div>
      </div>
    </div>
    <section class="content-header custom-header">
      <h1>{{LangSelected.Interno.CambioCuentaBancaria.Titulo}}</h1>
    </section>
    <section class="content container-fluid">
      <b-modal id="modal-1" ref="modal-1" :title=HeaderWarninigModal size="lg" centered button-size="sm" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true" style="width:90%;"
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
        <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px; padding:0px;">
          <div class="box box-default box-solid" style="margin-bottom: 4px;margin-top: 4px;">
            <div class="box-body">
              <p>{{LangSelected.Interno.CambioCuentaBancaria.ModalAvisoP1}}</p>
              <p>{{LangSelected.Interno.CambioCuentaBancaria.ModalAvisoP2}}</p>
            </div>
          </div>
        </div>
        <template #modal-footer="">
          <b-button size="sm" variant="primary"  @click="CloseModal()">
            {{LangSelected.Interno.CambioCuentaBancaria.BtnProceder}}
          </b-button>
        </template>
      </b-modal>
      <b-modal id="modal-3" ref="modal-3" :title="LangSelected.Interno.CambioCuentaBancaria.ModalEnProcesoTitulo" size="lg" centered button-size="sm" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true" style="width:90%;"
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
        <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px; padding:0px;">
          <div class="box box-default box-solid" style="margin-bottom: 4px;margin-top: 4px;">
            <div class="box-body">
              <p>{{LangSelected.Interno.CambioCuentaBancaria.ModalEnProceso}}</p>
            </div>
          </div>
        </div>
        <template #modal-footer="">
          <b-button size="sm" variant="primary"  @click="returnModal()">
            {{LangSelected.Interno.CambioCuentaBancaria.BtnRegresar}}
          </b-button>
        </template>
      </b-modal>
      <b-card no-body>
        <div class="row">
          <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
            <div class="col-sm-12">
              <span class="span-label" style="padding-top: 0px;">{{LangSelected.Interno.CambioCuentaBancaria.Motivo}}</span>
            </div>
            <div class="col-sm-12" style="padding-left: 15px;">
              <div class="value">
                <DxTextBox
                  v-model="selMotivo"
                  :placeholder="LangSelected.Interno.CambioCuentaBancaria.MotivoPH"
                  :max-length="100"
                />
              </div>
            </div>
          </div>
        </div>
        <b-tabs v-model="tabIndex" small card>
          <b-tab active>
            <template #title>
              <span>{{LangSelected.Externo.RegistroProveedor.tabCuentaBancaria}}
                <b-icon v-if="selMoneda && selBanco && selNumeroCuenta && selTitularCuenta && selABA && selSwiftCode" icon="check" variant="success"></b-icon>
                <b-icon v-else-if="!selMoneda && !selBanco && !selNumeroCuenta && !selTitularCuenta && !selABA && !selSwiftCode" icon="x" variant="danger"></b-icon>
                <b-icon v-else icon="exclamation" variant="warning"></b-icon>
              </span>
            </template>
            <div class="row">
              <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <div class="col-sm-4">
                  <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.Moneda}}</span>
                </div>
                <div class="col-sm-8" style="padding-left: 15px;">
                  <div class="value">
                  <DxSelectBox
                    :search-enabled="true"
                    :search-mode="searchModeOptionMon"
                    :search-expr="searchExprOptionMon"
                    :data-source="JSONMonedas"
                    value-expr="Id_Moneda"
                    display-expr="Moneda"
                    :value="selMoneda"
                    @valueChanged="changeMoneda"
                  />
                  </div>
                </div>
              </div>
              <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <div class="col-sm-4">
                  <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.Banco}}</span>
                </div>
                <div class="col-sm-8" style="padding-left: 15px;">
                  <div class="value">
                    <DxTextBox
                      v-model="selBanco"
                      :placeholder="LangSelected.Externo.RegistroProveedor.BancoHint"
                      :max-length="100"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <div class="col-sm-2 col-md-2 col-xs-4 col-lg-4">
                  <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.NumCuenta}}</span>
                </div>
                <div class="col-sm-10 col-md-10 col-xs-8 col-lg-8" style="padding-left: 15px;">
                  <div class="value">
                    <DxTextBox
                      v-model="selNumeroCuenta"
                      :placeholder="LangSelected.Externo.RegistroProveedor.NumCuentaHint"
                      :max-length="50"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <div class="col-sm-2 col-md-2 col-xs-4 col-lg-4">
                  <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.Titular}}</span>
                </div>
                <div class="col-sm-10 col-md-10 col-xs-8 col-lg-8" style="padding-left: 15px;">
                  <div class="value">
                    <DxTextBox
                      v-model="selTitularCuenta"
                      :placeholder="LangSelected.Externo.RegistroProveedor.TitularHint"
                      :max-length="255"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <div class="col-sm-4">
                  <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.ABA}}</span>
                </div>
                <div class="col-sm-8" style="padding-left: 15px;">
                  <div class="value">
                    <DxTextBox
                      v-model="selABA"
                      :placeholder="LangSelected.Externo.RegistroProveedor.ABAHint"
                      :max-length="50"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <div class="col-sm-4">
                  <span class="span-label" style="padding-top: 0px;">{{LangSelected.Externo.RegistroProveedor.SwiftCode}}</span>
                </div>
                <div class="col-sm-8" style="padding-left: 15px;">
                  <div class="value">
                    <DxTextBox
                      v-model="selSwiftCode"
                      :placeholder="LangSelected.Externo.RegistroProveedor.SwiftCode"
                      :max-length="50"
                    />
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab>
            <template #title>
              <span>{{LangSelected.Externo.RegistroProveedor.tabDocumentacion}} 
                <b-icon v-if="doc_status==2" icon="check" variant="success"></b-icon>
                <b-icon v-else-if="doc_status==1" icon="exclamation" variant="warning"></b-icon>
                <b-icon v-else-if="doc_status==0" icon="x" variant="danger"></b-icon>
              </span>
            </template>
            <!--<template #title>
              <span>{{LangSelected.Externo.RegistroProveedor.tabDocumentacion}} 
                <b-icon v-if="doc_status==2" icon="check" variant="success"></b-icon>
                <b-icon v-else-if="doc_status==1" icon="exclamation" variant="warning"></b-icon>
                <b-icon v-else-if="doc_status==0" icon="x" variant="danger"></b-icon>
              </span>
            </template>-->
            <DxDataGrid
              id="gridDocumentacion"
              :ref="gridDocumentacion"
              :data-source="JSONDocumentos"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :column-auto-width="true"
              :show-borders="true"
              key-expr="Id_ProveedorSolicitudDocumentacion"
            >
              <DxColumnChooser :enabled="false"/>
              <DxColumnFixing :enabled="true"/>
              <DxFilterRow :visible="true"/>
              <DxPaging :page-size="13"/>
              <DxPager
                :show-page-size-selector="true"
                :allowed-page-sizes="[]"
              />
              <DxColumn 
                :caption="LangSelected.Externo.RegistroProveedor.tbDocumento"
                data-field="Documento"
                alignment="left"
                :allow-editing="false"
                cell-template="cellTemplateDoc"
              />
              <DxColumn 
                :caption="LangSelected.Externo.RegistroProveedor.tbDescripcion"
                data-field="Descripcion"
                alignment="left"
                :allow-editing="false"
                cell-template="cellTemplateDesc"
              />
              <DxColumn
                :caption="LangSelected.Externo.RegistroProveedor.tbArchivo"
                data-field="NombreDocumento"
                alignment="center"
                :width="220"
                :allow-filtering="false"
                cell-template="cellTemplateArch"
              />
              <template #cellTemplateDoc={data}>
                <span class="color-upladed" v-if="data.data.NombreDocumento">{{data.data.Documento}}</span>
                <span v-else>{{data.data.Documento}}</span>
              </template>
              <template #cellTemplateDesc={data}>
                <span class="color-upladed" v-if="data.data.NombreDocumento" v-html="data.data.Descripcion" @click="findFunction(data.data.Descripcion)"></span>
                <span v-else v-html="data.data.Descripcion" @click="findFunction(data.data.Descripcion)"></span>
              </template>
              <template #cellTemplateArch={data}>
                <div v-if="data.data.NombreDocumento" style="margin: 2px auto;" @click="upFile(data)" v-b-modal.modal-2>
                  <p class="button-p-subir">{{data.data.NombreDocumento}}</p>
                  <span class="button-span-subir button-span-uploaded" :title=data.data.NombreDocumento>Reemplazar</span>
                </div>
                <span class="button-span-subir" v-else @click="upFile(data)" v-b-modal.modal-2>{{LangSelected.Externo.RegistroProveedor.tbSubir}}</span>
              </template>
            </DxDataGrid>
            <div class="row" v-if="SolicitudesPendientes==0">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin: 5px auto;text-align: right;">
                <!--<span style="border: solid thin #55afff;padding: 4px 5px;font-size: .8em;color: #FFFFFF;background: #55afff;cursor: pointer;" @click="tabIndex++">SIGUIENTE</span>-->
                <span style="border: solid thin #55afff;padding: 4px 5px;font-size: .8em;color: #FFFFFF;background: #55afff;cursor: pointer;" @click="guardarTabs()" v-show="disabledAll==false" :disabled=disabledAll>{{LangSelected.Externo.RegistroProveedor.BtnGuardarEnviar}}</span>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
      <b-modal id="modal-2" ref="modal-2" :title=HeaderDocumentosModal size="sl" button-size="sm" :no-close-on-esc="true" :no-close-on-backdrop="true" style="width:90%;">
        <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px; padding:0px;">
          <div class="box box-default box-solid" style="margin-bottom: 4px;margin-top: 4px;">
            <div class="box-body">
              <div class="row" style="margin-bottom: 10px;">
                <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                  <span class="col-sm-12 span-label" style="padding-top: 0px;padding-right: 0px;" v-html="DocumentosHint"></span>
                  <div class="col-sm-12">
                    <div class="fileuploader-container"><!--:allowed-file-extensions="['.pdf']"-->
                      <DxFileUploader
                        class="docUploader"
                        id="fileUploaderContainerDOC"
                        :select-button-text="LangSelected.Externo.RegistroProveedor.tbArchivo"
                        label-text=""
                        upload-mode="uploadMode"
                        :ref="refDOCUploader"
                        :disabled=docDisabled
                        :onValueChanged="onBeforeSend"
                        @value-changed="e => docfiles = e.value"
                        style="text-align:center;"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </section>
    <!--Modales-->
  </div>
</template>
<script>
import apiClient from '@/services/apiClient';
import notify from 'devextreme/ui/notify';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import DxSelectBox from 'devextreme-vue/select-box';
import DxTextBox from 'devextreme-vue/text-box';
import { DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxPager, DxFilterRow, DxPaging} from 'devextreme-vue/data-grid';
import { DxFileUploader } from 'devextreme-vue/file-uploader';

//const dataGridRef = 'dataGrid';
/*
i
import { DxCheckBox } from 'devextreme-vue/check-box';

//import { DxAutocomplete } from 'devextreme-vue/autocomplete';


import DxNumberBox from 'devextreme-vue/number-box';
//import DatePicker from 'vue2-datepicker';


//import func from 'vue-editor-bridge';
import DxTextArea from 'devextreme-vue/text-area';

import { confirm } from "devextreme/ui/dialog";

import { DxAutocomplete } from 'devextreme-vue/autocomplete';
import DxRadioGroup from 'devextreme-vue/radio-group';
*/

/*function escapeURI(value,EncodeDecode="e"){
  value=value.toString();
  if(EncodeDecode=="e"){
    value=value.replace(/'/g,"''");
    return window.encodeURIComponent(value);
  }else if(EncodeDecode=="d"){
    value=value.replace("%40","@");
    return window.decodeURI(value);
  }else{
    return "";
  }
}*/



export default {
  components:{
    DxLoadPanel,
    DxSelectBox,
    DxTextBox,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxPager, DxFilterRow, DxPaging,
    DxFileUploader/*, DxEditing/*,
    //DatePicker,
    DxAutocomplete,
    DxCheckBox,
    
    ,
    DxTextArea,
    DxRadioGroup,
    DxNumberBox,
   */
  },
  data(){
    return{
      //* G E N E R A L     V A R I A B L E S *//
      IDPU: localStorage.getItem('IDPU'),
      IDUS: localStorage.getItem('IDUS'),
      RFCP: localStorage.getItem('RFCP'),
      AREu: localStorage.getItem('AREu'),
      USER: localStorage.getItem('mail'),
      USERSIGA: localStorage.getItem('IDUSiga'),
      SolicitudesPendientes: 0,
      multiple:true,//Configuración de DxFileUploader multiple
      loadingVisible: false,//Configuracion de loader
      showIndicator: true,
      shading: true,
      showPane: true,
      closeOnOutsideClick: false,
      showSecondBoxInfo:false,
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      LangSelected:JSON.parse(localStorage.getItem('languageInfo')),
      languageSelected:localStorage.getItem('language'),

      //** M O D A L   W A R N I N G **//
      HeaderWarninigModal:'',
      headerBgVariant: 'danger',
      headerTextVariant: 'light',
      selMotivo:null,

      //* S O L I C I T U D   V A R I A B L E S *//
      tabIndex:1,
      JSONMonedas:[],
      selMoneda:null,
      searchModeOptionMon: 'contains',
      searchExprOptionMon: 'Moneda',
      selBanco:null,
      selNumeroCuenta:null,
      selTitularCuenta:null,
      selABA:null,
      selSwiftCode:null,

      //* D O C U M E N T A C I O N *//
      JSONDocumentos:[],
      gridDocumentacion: 'gridDocumentacion',
      Id_CurrentDocument:null,
      HeaderDocumentosModal:'',
      DocumentosHint:'',
      refDOCUploader: 'refDOCUploader',
      docDisabled: false,
      disabledAll: false,
      EstatusOverflow: false,
      docfiles: [],
      arrayDocuments:[],
      doc_status:0,
      getFunctionData:[],
      Biblioteca:null,
      Carpeta:null,
      SitioSharepoint:null,

      //* P R O G R E S O   C A R G A / D E S C A R G A *//
      showUploadProgress:false,
      uploadProgress:0,
      uploadBytes:{},
      showDownloadProgress:false,
      downloadProgress:0,
    };
  },
  computed: {
    
    /*dataGrid: function() {
        return this.$refs[dataGridRef].instance;
    }*/
    /*editRowKey: {
      get() {
        return this.$store.state.editRowKey;
      },
      set(value) {
        this.setEditRowKey(value);
      }
    },
    changes: {
      get() {
        return this.$store.state.changes;
      },
      set(value) {
        this.setChanges(value);
      }
    }*/
  },
  //* INICIANDO CONSULTAS *//
  created:function(){
  var that = this;
    if(that.AREu){
      that.HeaderWarninigModal = 'ATENCIÓN';
      that.loadingVisible = true;

      apiClient.get('/api/General/getMonedas-t', {
        params: { Todos: 0, FormatoXML: false }
      })
      .then(function (response) {
        that.JSONMonedas = response.data;
      })
      .catch(function (error) {
        notify(error, 'error');
        that.JSONMonedas = [];
      });

      apiClient.post('/api/Proveedores/DatosProveedorDocumentacion', {
        Id_Pais: 0,
        Id_TipoEmpresa: 0,
        Idioma: that.languageSelected || 'ES',
        Token: localStorage.getItem('token'),
        Id_Estatus: 21,
        Id_Proveedor: parseInt(that.IDUS) || 0,
        FormatoXML: false
      })
      .then(function (response) {
        that.JSONDocumentos = response.data;
      })
      .catch(function (error) {
        notify(error, 'error');
        that.JSONDocumentos = [];
      });

      apiClient.get('/api/CuentaBancaria/getDatosCambioCuentaBancaria', {
        params: { formatoXML: false }
      })
      .then(function (response) {
        var modulo = response.data;
        that.Biblioteca = modulo[0].BibliotecaSharepoint;
        that.Carpeta = modulo[0].PathSharepointPaso;
        that.SitioSharepoint = modulo[0].SitioSharepointPaso;
        that.SolicitudesPendientes = modulo[0].SolicitudesPendientes;
        if (modulo[0].SolicitudesPendientes >= 1) {
          that.$refs['modal-3'].show();
        } else {
          that.$refs['modal-1'].show();
        }
        that.loadingVisible = false;
      })
      .catch(function (error) {
        notify(error, 'error')
      });

      console.log(that.USER);
    }else{
      notify('Lo sentimos no tienes acceso a este apartado.', 'error');
      that.$router.push({name:'Home'});
    }
  },
  methods:{
    CloseModal: function(){
      var that=this;
      that.$refs['modal-1'].hide();
      //that.$refs['modal-7'].hide();
    },
    returnModal: function(){
      this.$router.push('/home');
      that.$refs['modal-1'].hide();
      that.$refs['modal-2'].hide();
      that.$refs['modal-3'].hide();
    },
    changeMoneda(e) {
      //var that = this;
      this.selMoneda = e.value;
      console.log(this.selMoneda);
    },
    findFunction:function(datos){
      var that = this;
      if(datos.indexOf("@click=")>=0){
        var splitLink = datos.split("@click="); splitLink = splitLink[1].split('"'); splitLink[1] = splitLink[1].replaceAll(")",""); splitLink = splitLink[1].split('('); if(splitLink[1]!=""){splitLink[1] = splitLink[1].split(",")}else{splitLink.pop();} //console.log(splitLink);
        that.getFunctionData = (splitLink.length>=2)?splitLink[1]:[];
        eval('that.'+splitLink[0]+"()");
      }
    },
    functionDescarga:function(){
      //solo se puede poner una @click por registro
      //ejemplo:
      //<a style="color:#007bff;" @click="functionName(variable 1,te la comes)">
      //no poner commillas (") dentro de la funcion

      console.log(""+ localStorage.getItem('token') + "")
      console.log(this.getFunctionData[0]);//Obtiene las variables dentro de la funcion (variable1,variable2,variable3,...)

      var that = this;
      that.downloadProgress = 0;
      that.showDownloadProgress = true;
      apiClient.get('/api/SharePoint/descargar-documento-t', {
        responseType: 'blob',
        onDownloadProgress: function (e) {
          if (e.total) {
            that.downloadProgress = Math.round((e.loaded / e.total) * 100);
          }
        },
        params: {
          SitioSharepoint: 'https://arendalgo.sharepoint.com/sites/'+this.getFunctionData[2],
          BibliotecaSharepoint: 'Documentos',
          PathSharepoint: this.getFunctionData[3],
          NombreArchivo: this.getFunctionData[0]
        }
      })
        .then(function (response) {
          console.log(response);
          var blob = new Blob([response.data]);
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = that.getFunctionData[0];
          link.click();
          that.showDownloadProgress = false;
        })
        .catch(function (error) {
          console.log('Error al descargar:', error);
          notify('Error al descargar el archivo', 'error');
          that.showDownloadProgress = false;
        });
    },
    upFile:function(registro) {
      var that = this;
      console.log(registro);
      that.HeaderDocumentosModal = registro.data.Documento;
      that.DocumentosHint = registro.data.Descripcion;
      that.Id_CurrentDocument = registro.data.Id_ProveedorSolicitudDocumentacion;
    },
    onBeforeSend:function(){
      console.log('Se resetea el doc')
      var that = this;
      //var url;
      const datosDOCFile = that.$refs[that.refDOCUploader].instance;
      const datosDOC = that.$refs[that.gridDocumentacion].instance;
      if(that.docfiles.length){
        console.log(that.docfiles);

        var selectedFiledoc = that.docfiles[0];

        // Validación de tamaño: archivo vacío (falla al cargar) y máximo 10 MB.
        if(selectedFiledoc.size === 0){
          notify('El archivo está vacío (0 bytes). Selecciona un archivo válido.', 'error', 7000);
          that.docfiles=[];
          datosDOCFile.reset();
          return false;
        }
        if(selectedFiledoc.size > 10*1024*1024){
          notify('El archivo supera el tamaño máximo permitido de 10 MB.', 'error', 7000);
          that.docfiles=[];
          datosDOCFile.reset();
          return false;
        }

        var extensiondoc = selectedFiledoc.name.substr( (selectedFiledoc.name.lastIndexOf('.') +1) );
        var newNamedoc = selectedFiledoc.name.split('.').slice(0, -1).join('.');
        newNamedoc = newNamedoc.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replaceAll(/[^\w\s]/gi,"");
        newNamedoc=newNamedoc+'.'+extensiondoc;
        console.log(extensiondoc.toLowerCase());
        console.log(newNamedoc);
        if(extensiondoc.toLowerCase()=='pdf' || extensiondoc.toLowerCase()=='jpg' || extensiondoc.toLowerCase()=='png' || extensiondoc.toLowerCase()=='doc' || extensiondoc.toLowerCase()=='docx'){
          console.log(selectedFiledoc);
          var findit = that.arrayDocuments.filter(function (data) { return data.Id_Doc == that.Id_CurrentDocument; });

          var FindItInOther = that.arrayDocuments.filter(function (data) { return data.Document.name == selectedFiledoc.name });
          console.log(FindItInOther);

          if(FindItInOther.length>=1){
            if(FindItInOther[0].Id_Doc!=that.Id_CurrentDocument){
              notify(that.LangSelected.Externo.RegistroProveedor.Notify.ArchivoExistente, 'warning', 7000);
              that.docfiles=[];
              datosDOCFile.reset();
              return false;
            }
          }

          var finditIndex = that.arrayDocuments.findIndex((obj => obj.Id_Doc == that.Id_CurrentDocument));
          if(findit.length>=1){
            that.arrayDocuments[finditIndex].Document=selectedFiledoc;
            that.arrayDocuments[finditIndex].NewName=newNamedoc;
          }else{
            that.arrayDocuments.push({Id_Doc:that.Id_CurrentDocument,Document:selectedFiledoc,NewName:newNamedoc});
          }
          console.log(that.arrayDocuments);


          
          ///var finditDoc = that.arrayDocuments.filter(function (data) { return data.Id_ProveedorSolicitudDocumentacion == that.Id_CurrentDocument; });
          var finditIndexDoc = that.JSONDocumentos.findIndex((obj => obj.Id_ProveedorSolicitudDocumentacion == that.Id_CurrentDocument));
          that.JSONDocumentos[finditIndexDoc].NombreDocumento = newNamedoc;
          //console.log(that.JSONDocumentos);

          //datosDOC.cellValue(that.Id_CurrentDocument,'NombreDocumento',newNamedoc);
          datosDOC.saveEditData();
          that.validarTabDocumentos();
          console.log(that.JSONDocumentos);
        }else{
          notify(that.LangSelected.Externo.RegistroProveedor.Notify.ExtencionIncorrecta, 'error',7000);
          datosDOCFile.reset();
        }
      }
    },
    validarTabDocumentos:function(){
      var that = this;
      console.log(that.arrayDocuments.length+"=="+that.JSONDocumentos.length);
      if(that.arrayDocuments.length == that.JSONDocumentos.length){
        that.doc_status = 2;
      }else if(that.arrayDocuments.length<=0){
        that.doc_status = 0;
      }else{
        that.doc_status = 1;
      }
    },
    guardarTabs:function(){

      var that = this;
      that.loadingVisible = true;
      var url = "";//22
      if(that.arrayDocuments.length == that.JSONDocumentos.length){
        if(that.selMoneda){
          if(that.selMotivo){
            if(that.selBanco){
              if(that.selNumeroCuenta){
                if(that.selTitularCuenta){
                  if(that.selABA){
                    if(that.selSwiftCode){
                      var formData;
                      that.selArchivosArray=[];
                      var pair;
                      var AllOk = true;
                      //var Id_ProveedoresSolicitudNuevoProv = that.Id_ProveedoresSolicitudNuevoProv;
                      //?GUARDAR DOCUMENTACION
                      that.uploadBytes = {};
                      that.uploadProgress = 0;
                      that.showUploadProgress = true;
                      $.each( that.arrayDocuments, function( key, value ) {
                        var d = new Date();
                        var month = d.getMonth()+1;
                        var day = d.getDate();
                        var day = d.getDate();
                        var time = d.toLocaleTimeString().replaceAll(":","");

                        var addDate = (day<10 ? '0' : '') + day + 
                            (month<10 ? '0' : '') + month + d.getFullYear()+(d.getMonth()+1)+
                            d.getFullYear()+time;

                        var selectedFile = value.Document;
                        var extension = selectedFile.name.substr( (selectedFile.name.lastIndexOf('.') +1) );
                        var newName = selectedFile.name.split('.').slice(0, -1).join('.');
                        newName = newName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replaceAll(/[^\w\s]/gi,"");
                        newName=newName+'.'+extension;

                        formData = new FormData();
                        formData.append('NombreArchivo', newName);
                        formData.append('BibliotecaSharepoint', that.Biblioteca);
                        formData.append('PathSharepoint', that.Carpeta);
                        formData.append('SitioSharepoint', that.SitioSharepoint);
                        formData.append('ReemplazarArchivo', 'true');
                        formData.append('file', value.Document);
                        for (pair of formData.entries()) {
                          console.log(pair[0]+ ', ' + pair[1]);
                        }
                        console.log(value.Document);
                        console.log(formData);
                        var rutas = that.SitioSharepoint+that.Biblioteca+that.Carpeta+newName;
                        console.log(rutas);
                        apiClient.post('/api/SharePoint/subir-archivo-t', formData, {
                          headers: { 'Content-Type': undefined },
                          onUploadProgress: function (e) {
                            that.$set(that.uploadBytes, newName, { loaded: e.loaded, total: e.total || e.loaded });
                            var loaded = 0, total = 0;
                            Object.keys(that.uploadBytes).forEach(function (k) {
                              loaded += that.uploadBytes[k].loaded;
                              total += that.uploadBytes[k].total;
                            });
                            that.uploadProgress = total ? Math.round((loaded / total) * 100) : 0;
                          }
                        })
                        .then(function (response) {
                            console.log(response);
                            that.selArchivosArray.push({
                              Id_SolicitudDocumentacion:""+value.Id_Doc+"",
                              NombreArchivo:""+newName+"",
                              PathArchivo:""+rutas+""
                            });
                            var isSuccess = (typeof response.data === 'string' && response.data.toLowerCase().includes('exitosamente')) || 
                                           (response.data && response.data.ERROR=="False");
                            if(isSuccess){
                              console.log('Archivo guardado correctamente');
                              console.log({AllOk:AllOk,selArchivosArray:that.selArchivosArray.length,arrayDocuments:(that.arrayDocuments.length)});
                              if(AllOk==true && that.selArchivosArray.length == that.arrayDocuments.length){
                                that.showUploadProgress = false;
                                /*var Id_Pais = that.selPais;
                                var RFC = that.selRFC.replace(/[/'"/g]/g, ""); //= escapeURI(that.selRFC,"e");
                                var NombreComercial = that.selComercial.replace(/[/'"/g]/g, ""); //= escapeURI(that.selComercial,"e");
                                var RazonSocial = that.selRazonSocial.replace(/[/'"/g]/g, ""); //= escapeURI(that.selRazonSocial,"e");
                                var TipoEmpresa = that.TipoEmpresa;
                                var DiasPlazo = that.selDias;
                                var CalleYNumero = that.selCalle.replace(/[/'"/g]/g, ""); //= escapeURI(that.selCalle,"e");
                                var Colonia = that.selColonia.replace(/[/'"/g]/g, ""); //= escapeURI(that.selColonia,"e");
                                var CP = that.selCP.replace(/[/'"/g]/g, ""); //= escapeURI(that.selCP,"e");
                                var Ciudad = that.selCiudad.replace(/[/'"/g]/g, ""); //= escapeURI(that.selCiudad,"e");
                                var Estado = that.selEstado.replace(/[/'"/g]/g, ""); //= escapeURI(that.selEstado,"e");
                                var NombreContacto = that.selNombres.replace(/[/'"/g]/g, ""); //= escapeURI(that.selNombres,"e");
                                var ApellidoContacto = that.selApellidos.replace(/[/'"/g]/g, ""); //= escapeURI(that.selApellidos,"e");
                                var ApellidoMaternoContacto = that.selApellidosM.replace(/[/'"/g]/g, ""); //= escapeURI(that.selApellidosM,"e");
                                var Puesto = that.selPuesto.replace(/[/'"/g]/g, ""); //= escapeURI(that.selPuesto,"e");
                                ///var CorreoElectronico = that.selCorreo; //= escapeURI(that.selCorreo,"e");
                                var Telefono = that.selTelefono; //= escapeURI(that.selTelefono,"e");
                                var Direccion = that.selDireccion.replace(/[/'"/g]/g, ""); //= escapeURI(that.selDireccion,"e");*/
                                var Motivo = that.selMotivo.replace(/[/'"/g]/g, ""); //= escapeURI(that.selMoneda,"e");
                                var Moneda = that.selMoneda.replace(/[/'"/g]/g, ""); //= escapeURI(that.selMoneda,"e");
                                var Banco = that.selBanco.replace(/[/'"/g]/g, ""); //= escapeURI(that.selBanco,"e");
                                var NumeroCuenta = that.selNumeroCuenta.replace(/[/'"/g]/g, ""); //= escapeURI(that.selNumeroCuenta,"e");
                                var TitularCuenta = that.selTitularCuenta.replace(/[/'"/g]/g, ""); //= escapeURI(that.selTitularCuenta,"e");
                                var ABA = that.selABA.replace(/[/'"/g]/g, ""); //= escapeURI(that.selABA,"e");
                                var SwiftCode = that.selSwiftCode.replace(/[/'"/g]/g, ""); //= escapeURI(that.selSwiftCode,"e");
                                console.log(that.selArchivosArray);
                                var languageSelected = (that.languageSelected)?that.languageSelected:"ES";
                                that.SolicitudesPendientes=0;
                                that.sp_prv_insSolicitudCambioCuenta_XML(""+that.$route.params.token+"", ""+Motivo+"", ""+Moneda+"", ""+Banco+"", ""+NumeroCuenta+"", ""+TitularCuenta+"", ""+ABA+"", ""+SwiftCode+"", ""+languageSelected+"");
                              } 
                            }else{
                              that.loadingVisible = false;
                              that.showUploadProgress = false;
                              console.log('Ocurrio un error inesperado contacte al administrador "'+response.data.ERROR + ' ' + response.data.MSN+' Line:1221"');
                              notify(that.LangSelected.Externo.RegistroProveedor.Notify.ErrorPeticion, 'error', 15000);
                              AllOk=false;
                            }
                        })
                        .catch(function (response) {
                          //handle error
                            AllOk=false;
                            console.log(response);
                            that.loadingVisible = false;
                            that.showUploadProgress = false;
                            console.log('Error al guardar xml: msg->' + response.data.MSN);
                            notify(that.LangSelected.Externo.RegistroProveedor.Notify.ErrorPeticion, 'error', 10000);
                        });
                      });
                    }else{
                      that.loadingVisible = false;
                      notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionSwiftCode, 'error');
                    }
                  }else{
                    that.loadingVisible = false;
                    notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionABA, 'error');
                  }
                }else{
                  that.loadingVisible = false;
                  notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionTitular, 'error');
                }
              }else{
                that.loadingVisible = false;
                notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionNoCuenta, 'error');
              }
            }else{
              that.loadingVisible = false;
              notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionBanco, 'error');
            }
          }else{
            that.loadingVisible = false;
            notify('Favor de seleccionar el motivo por el cual se hace la solicitud de cambio de cuenta.', 'error');
          }
        }else{
          that.loadingVisible = false;
          notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionMoneda, 'error');
        }
      }else{
        that.loadingVisible = false;
        notify(that.LangSelected.Externo.RegistroProveedor.Notify.ValidacionDocumentos, 'error');
      }
    },
    sp_prv_insSolicitudCambioCuenta_XML(Token, Motivo, Moneda, Banco, NumeroCuenta, TitularCuenta, ABA, SwiftCode, languageSelected){
      var that = this;
      apiClient.post('/api/CuentaBancaria/insSolicitudCambioCuenta', {
        Moneda: Moneda,
        NumeroCuenta: NumeroCuenta,
        TitularCuenta: TitularCuenta,
        ABA: ABA,
        SwiftCode: SwiftCode,
        Motivo: Motivo,
        Solicitante: that.USER,
        Banco: Banco,
        Documentos: that.selArchivosArray.map(d => ({
          Id_SolicitudDocumentacion: parseInt(d.Id_SolicitudDocumentacion) || 0,
          NombreArchivo: d.NombreArchivo,
          PathArchivo: d.PathArchivo
        })),
        FormatoXML: false
      }, { withLenguaje: true })
      .then(function (response) {
        var obj = response.data;
        console.log(obj);
        if(obj[0].Estatus == "ERROR"){
          notify(obj[0].Mensaje, 'error', 15000);
        }else if(obj[0].Estatus == "OK"){
          that.disabledAll = true;
          notify(obj[0].Mensaje, 'success', 15000);
        }else{
          notify(obj[0].Mensaje, 'error', 15000);
        }
        that.loadingVisible = false;
      })
      .catch(function (error) {
        console.log(error);
        that.loadingVisible = false;
      });
    },
    modoDebug(){
      var that = this;
      that.$refs['modal-1'].show();
      alert('Deveolp mode!');
    }
  }
}
</script>
<style scoped>
/* Overlay de progreso de carga/descarga (centrado) */
.cc-progress-overlay{
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
}
.cc-progress-card{
  background: #fff;
  border-radius: 14px;
  padding: 26px 34px;
  box-shadow: 0 10px 30px rgba(0,0,0,.25);
  min-width: 340px;
  max-width: 90%;
  text-align: center;
}
.cc-progress-label{
  margin: 0 0 14px;
  font-size: 15px;
  color: #333;
}
.cc-progress-track{
  height: 24px;
  border-radius: 50px;
  background: #e9ecef;
  overflow: hidden;
  border: 1px solid #d0d4d9;
}
.cc-progress-fill{
  height: 100%;
  border-radius: 50px;
  min-width: 6%;
  background-image: repeating-linear-gradient(45deg,#34c759 0,#34c759 12px,#2faa4d 12px,#2faa4d 24px);
  background-size: 48px 48px;
  animation: cc-stripes 1s linear infinite;
  transition: width .25s ease;
}
@keyframes cc-stripes{
  from{ background-position: 0 0; }
  to{ background-position: 48px 0; }
}

a{
  color: #313538 !important;
}

.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col, .col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm, .col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md, .col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg, .col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl, .col-xl-auto{
  display: inline-block;
}
.span-label{
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  font-weight: lighter;
  line-height: 1.5;
  color: #212529;
  text-align: left;
}
.dx-datagrid-headers{
  font-weight: bold;
}
.selector_action{
  height: 24px;
  padding: 0px 0px;
}
.DxDataGrid-txtbold{
  text-decoration: underline;
  color: rgb(60, 142, 190, 0.9) !important;
  font-weight: 700;
  cursor: pointer;
}
.btnSimple{
  background: rgb(60, 142, 190, 0.9) !important;
}
.box{
  box-shadow:none;
}
.checkboxTextStile{
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  font-weight: lighter;
  line-height: 1.5;
  color: #212529;
}
#modal-1___BV_modal_header_ h5{
 margin: auto !important;
}
.inputError{
  border: solid thin #ff000070;
}
.inputOk{
  border: solid thin #00800082;
}

.nav-link{
  display: block;
  padding: 0px !important;
}

.button-span-uploaded{
  color: white !important;
  padding: 3px 25% 3px 25%;
  border-color: #028002 !important;
  background: #459745 !important;
}
.color-upladed{
  color: #459745 !important;
}
.button-p-subir{
  white-space: initial;
  font-weight: 400;
  font-size: 10px;
  font-family: 'Helvetica Neue','Segoe UI',Helvetica,Verdana,sans-serif;
  margin: 0px 0px -10px 0px;
  border: solid thin #028002;
  border-radius: 5px 5px 0px 0px;
  background: #d1f9d1;
  cursor: pointer;
  padding: 0px 5px 10px 5px;
  overflow: hidden;
}
</style>